module.exports = __webpack_public_path__ + "img/feature13.5c50484.png";